import {useEffect,useRef} from 'react';

export default function WorkflowTabs({steps,activeSection,progress,onSelect,buttonStyle}){
 const rail=useRef();
 const counts=steps.map(s=>s.count||0).join(',');
 useEffect(()=>{
  function reveal(){
   const element=rail.current,selected=element?.querySelector('[aria-current="page"]');
   if(!element?.clientWidth||!selected)return;
   const left=selected.offsetLeft-6,right=selected.offsetLeft+selected.offsetWidth+6;
   let next=element.scrollLeft;
   if(left<next)next=left;else if(right>next+element.clientWidth)next=right-element.clientWidth;
   next=Math.max(0,Math.min(next,element.scrollWidth-element.clientWidth));
   // Scroll only this horizontal rail. scrollIntoView would move the whole page.
   if(next!==element.scrollLeft)element.scrollTo({left:next,behavior:'auto'});
  }
  reveal();window.addEventListener('resize',reveal);
  return()=>window.removeEventListener('resize',reveal);
 },[activeSection,counts]);
 return <div ref={rail} className="ts-tabs" role="navigation" aria-label="Inspection workflow">
  {steps.map(step=>{
   const complete=!!progress[step.key],active=activeSection===step.key;
   return <button key={step.key} type="button" aria-label={`${step.label}${step.count?` (${step.count} findings)`:''}${complete?' — complete':''}`} aria-current={active?'page':undefined} data-complete={complete} style={buttonStyle(active,complete)} onClick={()=>onSelect(step.key)}>
    {complete&&<span className="ts-step-check" aria-hidden="true">✓</span>}
    <span className={step.mobileLabel?'ts-step-label ts-step-label-desktop':'ts-step-label'}>{step.label}</span>
    {step.mobileLabel&&<span className="ts-step-label ts-step-label-mobile">{step.mobileLabel}</span>}
    {step.count>0&&<span className="ts-step-count" aria-hidden="true">{step.count}</span>}
   </button>;
  })}
 </div>;
}
